module.exports = __webpack_public_path__ + "img/16581301_L.56446964.png";